import { ru } from '@/locales/ru'

type Locale = 'ru'

const currentLocale: Locale = 'ru'

const locales = {
  ru,
}

export function useLocale() {
  const t = (key: string): string => {
    const keys = key.split('.')
    let value: any = locales[currentLocale]

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k]
      } else {
        console.warn(`Translation key not found: ${key}`)
        return key
      }
    }

    return typeof value === 'string' ? value : key
  }

  return {
    t,
    locale: currentLocale,
  }
}
